import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  authsignature,
  getSession,
  getStorage,
  getStorageEmail,
  getStorageExp,
  isYear,
  removeSession,
  removeStorage,
  setSession,
  storage,
  useWindowsSize,
} from "../../libs";
import { Divider, Drawer } from "antd";
import moment from "moment";
import NotificationDetail from "../Notification/NotificationDetail";

function Navbar({ props }) {
  const { onLocation } = props;
  const location = useLocation();
  const history = useHistory();
  const size = useWindowsSize();
  const dataSession = getSession();

  const [visible, setVisible] = useState(false); //untuk visible di login register atau account
  const [account, setAccount] = useState(false); //check untuk account atau homepage
  const [token, setToken] = useState({ token: null, xtoken: null });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isName, setName] = useState("");
  const [isDrawer, setDrawer] = useState(false); //handle open drawer
  const [empty, setEmpty] = useState(false);

  const [isModal, setModal] = useState(false); // handle open modal
  const [isDetail, setDetail] = useState({});

  const storages = async () => {
    const initToken = getStorage();
    const initXtoken = await getStorageEmail();
    const initExptoken = await getStorageExp();

    setToken({
      ...token,
      token: initToken,
      xtoken: initXtoken,
    });

    if (initToken && initXtoken && initExptoken) {
      await GetData();

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/profile/detail`,
        { email: initXtoken },
        { headers: await authsignature(initToken, { email: initXtoken }) }
      );

      if (Number(response.data.code) === 200) {
        setName(
          response.data.data.first_name +
            " " +
            (response.data.data.last_name === null
              ? ""
              : response.data.data.last_name)
        );
      } else {
        setName("");
        await removeData();
      }
    }
  };

  const GetData = async () => {
    const auth = getStorage();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notif`,
        { offset: "0", limit: "10", read: "0" },
        {
          headers: await authsignature(auth, {
            offset: "0",
            limit: "10",
            read: "0",
          }),
        }
      );

      if (Number(response.data.code) === 200) {
        const dataFilter = await response.data.data.filter(
          (it) => it.status === 0
        );
        const dataSlice =
          dataFilter.length > 3 ? dataFilter.slice(0, 3) : dataFilter;
        setData(dataSlice);
      } else {
        setData([]);
        await removeData();
      }
    } catch (e) {
      setData([]);
      await removeData();
    }
  };

  const expired = async () => {
    const expToken = await getStorageExp();

    if (expToken) {
      const datenow = moment().format("YYYY-MM-DD HH:mm:ss");
      const checking = moment(expToken).isBefore(datenow, "day");

      if (checking) {
        await removeData();
      }
    }
  };

  const removeData = async () => {
    await removeStorage();
    removeSession();
    setLoading(false);
    history.push("/");
    window.location.reload();
  };

  useEffect(() => {
    if (location) {
      storages();
      onLocation(location.pathname);
      if (
        location.pathname === "/account/login" ||
        location.pathname === "/account/register"
      ) {
        setVisible(false);
      } else {
        setVisible(true);
        setAccount(false);
      }

      if (location.pathname.includes("account")) {
        setAccount(true);
      }

      if (
        location.pathname.includes("account") ||
        location.pathname.includes("profile") ||
        location.pathname.includes("product") ||
        location.pathname.includes("media") ||
        location.pathname.includes("profile") ||
        location.pathname.includes("history") ||
        location.pathname.includes("cart") ||
        location.pathname.includes("lacak") ||
        location.pathname.includes("frequently")
      ) {
        setEmpty(false);
      } else {
        setEmpty(true);
      }

      if (dataSession && location.pathname.includes("cart")) {
        let session = JSON.parse(dataSession);

        session.item.parameter =
          session.item.parameter.length > 0
            ? session.item.parameter.map((o) =>
                Object.assign({}, o, { active: true })
              )
            : [];

        session.item.paket =
          session.item.paket.length > 0
            ? session.item.paket.map((o) =>
                Object.assign({}, o, { active: true })
              )
            : [];

        session.item.product =
          session.item.product.length > 0
            ? session.item.product.map((o) =>
                Object.assign({}, o, { active: true })
              )
            : [];

        setSession(JSON.stringify(session));
      }

      expired();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const onLogout = async () => {
    setLoading(true);
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/logout`,
      {},
      { headers: { Authorization: `Bearer ${token.token}` } }
    );

    await removeData();
  };

  const onDrawer = () => {
    if (isDrawer) {
      setDrawer(false);
    } else {
      scrollToTop();
      setDrawer(true);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onRead = async (data) => {
    try {
      const auth = await storage();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notif-read`,
        { notif_id: data.notif_id },
        {
          headers: await authsignature(auth.token, { notif_id: data.notif_id }),
        }
      );
      setModal(true);
      setDetail(data);
    } catch (e) {}
  };

  const onClose = () => {
    setModal(false);
    history.push("/");
  };

  return (
    <>
      <NotificationDetail props={{ isModal, onClose, isDetail }} />
      {isDrawer && (
        <div className="relative">
          <img
            onClick={onDrawer}
            src={
              process.env.REACT_APP_BASE_URL +
              "/assets/icon/ic_close_mobile.svg"
            }
            alt="icon-close"
            className="absolute h-7 w-auto cursor-pointer top-5 left-5 z-30 "
          />
        </div>
      )}
      <Drawer
        placement="right"
        closable={false}
        onClose={onDrawer}
        visible={isDrawer}
        width="300"
        // maskClosable={false}
        zIndex={25}
      >
        <div>
          <div name="logo-header">
            <p className="m-0 header-content colors-gray text-xs mb-2">
              Dipersembahkan oleh
            </p>
            <div className="flex">
              <Link to="/">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/logo/logo_kemenkes.svg"
                  }
                  alt="kemenkes-logo"
                  className="cursor-pointer h-8 w-auto mr-8"
                />
              </Link>
              <img
                onClick={() => {
                  onDrawer();
                  history.push("/");
                }}
                src={
                  process.env.REACT_APP_BASE_URL + "/assets/logo/logo_blk.svg"
                }
                alt="blk-logo"
                className="cursor-pointer h-8 w-auto "
              />
            </div>
          </div>
          <div className="flex items-center content-center w-full text-white mt-10">
            <div className="w-12 h-12 mr-5">
              <img
                className="w-12 h-12  object-cover rounded-3xl "
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/image/img_profile.png"
                }
                alt="img-profile"
              />
            </div>
            <div>
              <p className="header-title colors-blue text-base">
                {/* <b>Angga</b> Praja */}
                {isName}
              </p>
              <p className=" header-content text-sm colors-gray">
                Membership BBLK
              </p>
            </div>
          </div>
        </div>
        <div name="menu-secion" className="my-10">
          <Link to="/">
            <div
              className="flex justify-between cursor-pointer items-center mb-4"
              onClick={onDrawer}
            >
              <p className="text-base colors-gray-old header-content">Home</p>
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_pop_right.svg"
                }
                alt="icon-right"
                className="cursor-pointer"
              />
            </div>
          </Link>
          <Link to="/profile">
            <div
              className="flex justify-between cursor-pointer items-center"
              onClick={onDrawer}
            >
              <p className="text-base colors-gray-old">Profile Saya</p>
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_pop_right.svg"
                }
                alt="icon-right"
                className="cursor-pointer"
              />
            </div>
          </Link>

          <Link to="/profile/history">
            <div
              className="flex justify-between cursor-pointer my-4 items-center"
              onClick={onDrawer}
            >
              <p className="text-base colors-gray-old">Riwayat Transaksi</p>
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_pop_right.svg"
                }
                alt="icon-right"
                className="cursor-pointer"
              />
            </div>
          </Link>
          <Link to="/profile/setting">
            <div
              className="flex justify-between cursor-pointer mb-4 items-center"
              onClick={onDrawer}
            >
              <p className="text-base colors-gray-old">Pengaturan</p>
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_pop_right.svg"
                }
                alt="icon-right"
                className="cursor-pointer"
              />
            </div>
          </Link>
          <Link to="/profile/notification">
            <div
              className="flex justify-between cursor-pointer items-center"
              onClick={onDrawer}
            >
              <p className="text-base colors-gray-old">Notifikasi</p>
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_pop_right.svg"
                }
                alt="icon-right"
                className="cursor-pointer"
              />
            </div>
          </Link>
        </div>
        <div name="button-logout" className="pb-6">
          <div className="w-full h-9 flex justify-center">
            <button
              disabled={loading}
              onClick={onLogout}
              className={`${
                loading
                  ? "navbar-button-logout-loading"
                  : "navbar-button-logout"
              } focus:outline-none text-white w-4/5`}
            >
              {loading ? <p>Loading</p> : <p>Logout</p>}
            </button>
          </div>
        </div>
        <div className="flex justify-center">
          <div>
            <div className="mt-5 flex justify-center items-center">
              <p className="m-0 colors-blue text-sm mr-3 header-content">
                Ikuti kami di
              </p>

              <a
                href={process.env.REACT_APP_FACEBOOK}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/socialmedia/ic_fb.svg"
                  }
                  alt="icon-fb"
                  className="cursor-pointer h-3 w-auto mr-2"
                />
              </a>

              <a
                href={process.env.REACT_APP_INSTAGRAM}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/socialmedia/ic_ig.svg"
                  }
                  alt="icon-ig"
                  className="cursor-pointer h-3 w-auto mr-2"
                />
              </a>

              <a
                href={process.env.REACT_APP_TWITTER}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/socialmedia/ic_twitter.svg"
                  }
                  alt="icon-twitter"
                  className="cursor-pointer h-3 w-auto mr-2"
                />
              </a>
            </div>
            <div className="flex justify-center lg:justify-start w-full">
              <div>
                <p className="header-title-bold text-lg text-center lg:text-left colors-blue font-bold mt-3 lg:mt-0 lg:m-0 mb-3">
                  Hubungi Kami
                </p>
                <div className="grid grid-cols-1 grid-rows-1 lg:grid-cols-2 gap-1 lg:gap-5">
                  <div className="lg:mr-5">
                    <div className="flex items-center">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_footer_phone.svg"
                        }
                        alt="icon-phone"
                        className="mr-4 h-3 w-3"
                      />
                      <p className="header-content m-0 text-xs colors-gray">
                        031-5020306, 031-5021451
                      </p>
                    </div>
                    <div className="flex items-center my-1">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_footer_fax.svg"
                        }
                        alt="icon-fax"
                        className="mr-4 h-3 w-3"
                      />
                      <p className="header-content m-0 text-xs colors-gray">
                        031-5020388
                      </p>
                    </div>
                    <div className="flex items-center">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_footer_email.svg"
                        }
                        alt="icon-email"
                        className="mr-4 h-3 w-3"
                      />
                      <p className="header-content m-0 text-xs colors-gray">
                        bblksub@yahoo.co.id
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-baseline ">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_footer_location.svg"
                        }
                        alt="icon-location"
                        className="mr-4 h-3 w-3"
                      />
                      <p className="header-content m-0 text-xs colors-gray w-3/4 lg:w-2/3">
                        Jl. Karangmenjangan 18 Surabaya 60286
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 lg:mt-0">
              <a
                href={process.env.REACT_APP_PLAYSTORE}
                target="_blank"
                rel="noreferrer"
              >
                <div className="flex justify-center lg:justify-between">
                  <div></div>
                  <div className="footer-playstore w-5/6 px-4 py-2 lg:px-6 cursor-pointer">
                    <div className="flex items-center">
                      <div className="mr-5">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_footer_playstore.svg"
                          }
                          alt="icon-playstore"
                        />
                      </div>
                      <div>
                        <p className="text-xs  header-content m-0 text-white">
                          Get it on
                        </p>
                        <p className="text-md header-title-semi  m-0 text-white">
                          Google play
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <div className="flex justify-center lg:justify-between items-center mt-6 lg:mt-3">
                <p className="lg:ml-20 mr-8 lg:mr-0 colors-gray font-semibold m-0 cursor-pointer header-title-semi">
                  FAQ
                </p>
                <p className="colors-gray font-semibold m-0 cursor-pointer header-title-semi">
                  Term and Condition
                </p>
              </div>
              <div>
                <p className="m-0 text-xs mt-1 text-center lg:text-right colors-blue header-content">
                  Copyright © {isYear}. BBLK Surabaya. All Right Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Drawer>

      {!empty || location.pathname === "/" ? (
        visible ? (
          account ? (
            // Navbar Khusus Login, Register, Forgot ------>
            <div className="w-full bg-white navbar sticky top-0">
              <div className="container mx-auto bg-transparent  flex item-center justify-between py-5">
                <div name="logo" className="flex items-center">
                  <Link to="/">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/logo/logo_kemenkes.svg"
                      }
                      alt="kemenkes-logo"
                      className="h-10 w-auto mr-10 lg:mr-10 cursor-pointer"
                    />
                  </Link>
                  <Link to="/">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/logo/logo_blk.svg"
                      }
                      alt="blk-logo"
                      className="h-10 cursor-pointer w-auto "
                    />
                  </Link>
                </div>
                <div className="flex items-center">
                  {size.width > 640 && (
                    <>
                      <p className="header-title-semi m-0 mr-2 navbar-download">
                        Download | Ikuti kami di
                      </p>

                      <a
                        href={process.env.REACT_APP_FACEBOOK}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/socialmedia/ic_fb.svg"
                          }
                          alt="icon-fb"
                          className="h-3 w-auto mr-2 cursor-pointer"
                        />
                      </a>

                      <a
                        href={process.env.REACT_APP_INSTAGRAM}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/socialmedia/ic_ig.svg"
                          }
                          alt="icon-ig"
                          className="h-4 w-auto mr-2 cursor-pointer"
                        />
                      </a>

                      <a
                        href={process.env.REACT_APP_TWITTER}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/socialmedia/ic_twitter.svg"
                          }
                          alt="icon-twitter"
                          className="h-3 w-auto mr-2 cursor-pointer"
                        />
                      </a>
                    </>
                  )}
                </div>
                <div className="flex items-center">
                  {token.token && token.xtoken ? (
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_down.svg"
                      }
                      alt="icon-dropdown"
                      className="cursor-pointer"
                    />
                  ) : (
                    size.width > 640 && (
                      <div className="flex items-center">
                        <p className="header-title navbar-ingat  mr-2  font-semibold ">
                          Ingat password anda ?
                        </p>
                        <Link to="/account/login">
                          <button className="p-1 px-2 focus:outline-none navbar-button">
                            <p className="m-0 text-blue-900 font-bold header-title-bold">
                              Login
                            </p>
                          </button>
                        </Link>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          ) : // Mode Desktop
          size.width > 640 ? (
            <div className="w-full bg-white navbar sticky top-0">
              <div className="container mx-auto bg-transparent  flex item-center justify-between py-5">
                <div name="logo" className="flex items-center">
                  <Link to="/">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/logo/logo_kemenkes.svg"
                      }
                      alt="kemenkes-logo"
                      className="h-10 w-auto mr-10 lg:mr-10 cursor-pointer"
                    />
                  </Link>
                  <Link to="/">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/logo/logo_blk.svg"
                      }
                      alt="blk-logo"
                      className="h-10 cursor-pointer w-auto "
                    />
                  </Link>
                </div>
                <div className="flex items-center">
                  <p className="header-title-semi m-0 mr-2 navbar-download ">
                    Download | Ikuti kami di
                  </p>

                  <a
                    href={process.env.REACT_APP_FACEBOOK}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/socialmedia/ic_fb.svg"
                      }
                      alt="icon-fb"
                      className="h-3 w-auto mr-2 cursor-pointer"
                    />
                  </a>

                  <a
                    href={process.env.REACT_APP_INSTAGRAM}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/socialmedia/ic_ig.svg"
                      }
                      alt="icon-ig"
                      className="h-4 w-auto mr-2 cursor-pointer"
                    />
                  </a>

                  <a
                    href={process.env.REACT_APP_TWITTER}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/socialmedia/ic_twitter.svg"
                      }
                      alt="icon-twitter"
                      className="h-3 w-auto mr-2 cursor-pointer"
                    />
                  </a>
                </div>

                {/* Mulai Masuk Link CART */}
                <div className="flex items-center">
                  {token.token && token.xtoken && (
                    <>
                      <Link to="/cart">
                        <div className="relative">
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_cart.svg"
                            }
                            alt="icon-cart"
                            className="h-5 w-auto mr-5 cursor-pointer"
                          />
                          {dataSession && (
                            <div className="absolute top-0 left-3">
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "/assets/icon/ic_cart_on.svg"
                                }
                                alt="icon-cart-on"
                                // className="h-5 w-auto mr-5 cursor-pointer"
                              />
                            </div>
                          )}
                        </div>
                      </Link>
                      <Link to="/profile/history">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_history.svg"
                          }
                          alt="icon-history"
                          className="h-5 w-auto mr-5 cursor-pointer"
                        />
                      </Link>

                      <div className="popover__wrapper">
                        <div className="relative">
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_notification.svg"
                            }
                            alt="icon-notif"
                            className="h-5 w-auto mr-5 cursor-pointer popover__title cursor-pointer"
                          />
                          {data.length > 0 && (
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                "/assets/icon/ic_notif_active.svg"
                              }
                              alt="icon-notif"
                              className="absolute top-0 left-3 cursor-pointer"
                            />
                          )}
                        </div>
                        <div className="popover__content">
                          <div className=" popover__content_wrappers p-4">
                            {data.map((it, index) => (
                              <div key={index}>
                                <div className="flex items-start">
                                  <img
                                    src={
                                      process.env.REACT_APP_BASE_URL +
                                      "/assets/icon/ic_notif_promo.svg"
                                    }
                                    alt="icon-promo"
                                    className="mr-3 cursor-pointer"
                                  />
                                  <div className="w-11/12">
                                    <p className="truncate w-5/6 header-title-bold">
                                      {it?.title ?? ""}
                                    </p>
                                    <p className="header-title mt-1">
                                      {it.body.length > 50
                                        ? it.body.slice(0, 50) + "..."
                                        : it?.body ?? ""}
                                    </p>

                                    <div className="flex items-center w-5/6 justify-between mt-2">
                                      <p className="text-xs">
                                        {moment(
                                          it?.created_at ?? "00-00-0000"
                                        ).format("DD MMMM YYYY")}
                                      </p>
                                      <div
                                        onClick={() => {
                                          onRead({
                                            notif_id: it.id,
                                            title: it?.title ?? "",
                                            content: it?.body ?? "",
                                            date:
                                              it?.created_at ?? "00-00-0000",
                                          });
                                        }}
                                      >
                                        <p className="colors-blue header-title-semi cursor-pointer text-xs">
                                          Lihat Detail
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <Divider />
                              </div>
                            ))}
                            {data.length === 0 && (
                              <div>
                                <div className="flex w-full justify-center">
                                  <img
                                    src={
                                      process.env.REACT_APP_BASE_URL +
                                      "/assets/icon/ic_notif_promo.svg"
                                    }
                                    alt="icon-promo"
                                    className="mt-5 w-10 h-10"
                                  />
                                </div>
                                <p className="colors-blue text-xl mb-5 mt-2 text-center header-title-bold">
                                  Tidak ada Notifikasi
                                </p>
                              </div>
                            )}

                            {data.length > 0 && (
                              <Link to="/profile/notification">
                                <p className="colors-blue text-center header-title-bold cursor-pointer">
                                  Lihat Semua
                                </p>
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {token.token && token.xtoken ? (
                    <div className="popover__wrapper">
                      <div className=" popover__title flex items-center cursor-pointer">
                        <div className="w-6 h-6 mr-2">
                          <img
                            className="w-6 h-6  object-cover rounded-2xl "
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/image/img_profile.png"
                            }
                            alt="img-profile"
                          />
                        </div>
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_down.svg"
                          }
                          alt="icon-dropdown"
                          className="cursor-pointer"
                        />
                      </div>
                      <div className="popover__content">
                        <div className=" popover__content_wrapper">
                          <div className="navbar-header-section py-8 flex items-center justify-center content-center w-full h-10 text-white">
                            <div className="w-8 h-8 mr-5">
                              <img
                                className="w-8 h-8  object-cover rounded-3xl "
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "/assets/image/img_profile.png"
                                }
                                alt="img-profile"
                              />
                            </div>
                            <div>
                              <p className="text-base">
                                {/* <b>Angga</b> Praja */}
                                {isName}
                              </p>
                              <p className="text-sm colors-gray">
                                Membership BBLK
                              </p>
                            </div>
                          </div>
                          <div className="p-6">
                            <Link to="/profile">
                              <div className="flex justify-between cursor-pointer items-center">
                                <p className="text-base colors-gray-old header-content">
                                  Profil Saya
                                </p>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_pop_right.svg"
                                  }
                                  alt="icon-right"
                                  className="cursor-pointer"
                                />
                              </div>
                            </Link>
                            <Link to="/profile/history">
                              <div className="flex justify-between cursor-pointer my-6 items-center">
                                <p className="text-base colors-gray-old header-content">
                                  Riwayat Transaksi
                                </p>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_pop_right.svg"
                                  }
                                  alt="icon-right"
                                  className="cursor-pointer"
                                />
                              </div>
                            </Link>
                            <Link to="/profile/setting">
                              <div className="flex justify-between cursor-pointer items-center">
                                <p className="text-base colors-gray-old header-content">
                                  Pengaturan
                                </p>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_pop_right.svg"
                                  }
                                  alt="icon-right"
                                  className="cursor-pointer"
                                />
                              </div>
                            </Link>
                          </div>
                          <div className="pb-6">
                            <div className="w-full h-9 flex justify-center">
                              <button
                                disabled={loading}
                                onClick={onLogout}
                                className={`${
                                  loading
                                    ? "navbar-button-logout-loading"
                                    : "navbar-button-logout"
                                } focus:outline-none text-white w-3/5`}
                              >
                                {loading ? (
                                  <p className="header-content">Loading</p>
                                ) : (
                                  <p className="header-content">Logout</p>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center">
                      <Link to="/account/login">
                        <button className="p-1 px-2 focus:outline-none mr-5 navbar-button">
                          <p className="header-title-bold m-0 text-blue-900 font-bold">
                            Login
                          </p>
                        </button>
                      </Link>
                      <Link to="/account/register">
                        <p className="header-title-bold cursor-pointer m-0 text-blue-900 font-bold ">
                          Sign up
                        </p>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            // Mode Mobile
            <div className="w-full bg-white navbar sticky top-0 relative z-20">
              <div className="container mx-auto bg-transparent  flex item-center justify-between py-5">
                {token.token && token.xtoken ? (
                  !isDrawer ? (
                    <div
                      name="menu"
                      className="flex items-center"
                      onClick={onDrawer}
                    >
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_menu.svg"
                        }
                        alt="icon-menu"
                        className="h-6 w-auto cursor-pointer"
                      />
                    </div>
                  ) : (
                    <div className="flex items-center h-6"></div>
                  )
                ) : (
                  <div name="logo-header">
                    <div className="flex">
                      <Link to="/">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/logo/logo_kemenkes.svg"
                          }
                          alt="kemenkes-logo"
                          className="cursor-pointer h-7 w-auto mr-5"
                        />
                      </Link>
                      <img
                        onClick={() => {
                          // onDrawer();
                          history.push("/");
                        }}
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/logo/logo_blk.svg"
                        }
                        alt="blk-logo"
                        className="cursor-pointer h-7 w-auto "
                      />
                    </div>
                  </div>
                )}

                {token.token && token.xtoken ? (
                  <div className="flex items-center">
                    <Link to="/cart">
                      <div className="relative">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_cart.svg"
                          }
                          alt="icon-cart"
                          className="h-5 w-auto mr-5 cursor-pointer"
                        />
                        {dataSession && (
                          // <div className="absolute top-0 -right-5">
                          <div className="absolute top-0 left-3">
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                "/assets/icon/ic_cart_on.svg"
                              }
                              alt="icon-cart-on"
                              // className="h-5 w-auto mr-5 cursor-pointer"
                            />
                          </div>
                        )}
                      </div>
                    </Link>
                    <Link to="/profile/history">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_history.svg"
                        }
                        alt="icon-history"
                        className="h-5 w-auto mr-5 cursor-pointer"
                      />
                    </Link>

                    <Link to="/profile/notification">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_notification.svg"
                        }
                        alt="icon-notif"
                        className="h-5 w-auto mr-5 cursor-pointer"
                      />
                    </Link>
                  </div>
                ) : (
                  <Link to="/account/login">
                    <button className="p-1 px-2 focus:outline-none navbar-button">
                      <p className="header-title-bold m-0 text-blue-900 font-bold">
                        Login
                      </p>
                    </button>
                  </Link>
                )}
              </div>
            </div>
          )
        ) : null
      ) : null}
    </>
  );
}

export default Navbar;
